<div class="lead-gen-page">
  <form name="leadGenForm" #qqForm="ngForm" class="lead-gen-page">
    <div class="title" *ngIf="page.showHeader">{{ page.title }}</div>

    <div class="cube">
      <div class="filler"></div>

      <div class="questions">
        <div *ngFor="let question of page.questions; index as i" class="question">
          <ng-container [ngSwitch]="question.type">
            <app-site-content *ngSwitchCase="'SiteContent'" [key]="question.key"> </app-site-content>

            <app-question
              *ngSwitchDefault
              [question]="question"
              [showHeader]="page.questions.length &gt; 1 || page.questions.length === 1"
              [autofocus]="i === 0">
            </app-question>
          </ng-container>
        </div>

        <app-paging
          class="app-paging"
          [page]="page"
          [valid]="qqForm.form.valid"
          [firstPage]="firstPage"
          (showInvalid)="showInvalid()"
          [nextBtnText]="nextButtonText">
        </app-paging>
      </div>

      @if (footerKey) {
        <app-site-content class="footer" [key]="footerKey"> </app-site-content>
      }
    </div>
  </form>
</div>
